import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "add-item"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "btn-group"
};
import { ref, toRefs, onMounted, reactive, watch, toRaw } from 'vue';
import { ElMessage } from 'element-plus';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
import DialogHeader from '@/components/dialog-header/index.vue';
import { deepClone } from '@/utils/util';
import { timeZoneOptions } from '@/utils/timezoneList';
export default /*@__PURE__*/_defineComponent({
  __name: 'preference-dialog',
  props: {
    visible: {
      type: Boolean
    }
  },
  emits: ["update:visible"],
  setup(__props, {
    emit: __emit
  }) {
    const userDefaultSettingStore = useUserDefaultSettingStore();
    const {
      preferences
    } = storeToRefs(userDefaultSettingStore);
    const {
      setPreferences
    } = userDefaultSettingStore;
    const props = __props;
    const {
      visible
    } = toRefs(props);
    const emits = __emit;
    const dialogVisible = ref(false);
    const ruleFormRef = ref();
    const ruleForm = reactive({
      alertOnly: 0,
      collapseLeftMenu: false,
      theme: 'device-theme',
      localTimeZone: false,
      timezone: 0
    });
    const rules = reactive({
      alertOnly: [{
        required: true,
        message: 'Please select',
        trigger: 'change'
      }],
      collapseLeftMenu: [{
        required: true,
        message: 'Please select',
        trigger: 'change'
      }],
      theme: [{
        required: true,
        message: 'Please select',
        trigger: 'change'
      }],
      localTimeZone: [{
        required: true,
        message: 'Please select',
        trigger: 'change'
      }]
    });
    const toggleTheme = () => {
      if (ruleForm.theme === 'device-theme') {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        if (mediaQuery) {
          document.documentElement.classList.add('dark-theme');
        } else {
          document.documentElement.classList.remove('dark-theme');
        }
      } else {
        document.documentElement.className = ruleForm.theme;
      }
    };
    const handleBeforeClose = () => {
      emits('update:visible', false);
    };
    const handleCancel = () => {
      emits('update:visible', false);
    };
    const resetForm = () => {
      if (!ruleFormRef.value) return;
      ruleFormRef.value.resetFields();
    };
    const handleSubmit = async () => {
      if (!ruleFormRef.value) return;
      await ruleFormRef.value.validate(valid => {
        if (valid) {
          saveSubmit();
        }
      });
    };
    const saveSubmit = async () => {
      const rawRuleForm = deepClone(toRaw(ruleForm));
      for (const key in rawRuleForm) {
        preferences.value[key] = rawRuleForm[key];
      }
      await setPreferences();
      emits('update:visible', false);
      ElMessage({
        message: 'Your preference has been saved',
        type: 'success'
      });
    };
    const initForm = () => {
      ruleForm.alertOnly = preferences.value.alertOnly || 0;
      ruleForm.collapseLeftMenu = preferences.value.collapseLeftMenu || false;
      ruleForm.theme = preferences.value.theme || 'device-theme';
      ruleForm.timezone = preferences.value.timezone || 0;
    };
    onMounted(() => {
      dialogVisible.value = visible.value;
    });
    watch(() => visible.value, () => {
      dialogVisible.value = visible.value;
      if (dialogVisible.value) {
        resetForm();
        initForm();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        "show-close": false,
        width: "40%",
        "before-close": handleBeforeClose
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": "Preferences Setting",
          "guide-link": "aaa"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm,
          rules: rules,
          "label-width": "200px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "Collapse left menu",
            prop: "collapseLeftMenu"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox, {
              modelValue: ruleForm.collapseLeftMenu,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleForm.collapseLeftMenu = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Page theme",
            prop: "theme",
            onChange: toggleTheme
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: ruleForm.theme,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ruleForm.theme = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                value: "light-theme"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("Light")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: "dark-theme"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("Dark")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: "device-theme"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("Device")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Time Zone",
            prop: "timezone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: ruleForm.timezone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ruleForm.timezone = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeZoneOptions), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.label,
                  value: item.value,
                  key: item.label
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: handleCancel
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("Cancel")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("Submit")])),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});